<template>
<div>
  <v-app-bar color="blue accent-1" >
      <v-app-bar-nav-icon color="white" @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">Hana's English</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn outlined small>Login</v-btn> -->
  </v-app-bar>
    <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    >
      <sideBar @setSubCategory="setSubCategory"/>
    </v-navigation-drawer>
  <v-container>
    <v-card class="pa-2">
      <v-card-title>
        Hana's Background
      </v-card-title>
      <v-divider class="mx-2"/>
      <v-card-text v-html="userinfor.about_me"></v-card-text>
      <v-list>
        <v-divider  class="mx-2" />
        <div v-for="history in historys" :key="history.id">
            <v-list-item>
              <v-list-item-action>
                <v-list-item-title>
                  {{history.history_date}}
                </v-list-item-title>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{history.title}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          <v-divider  class="mx-2" />
        </div>
      </v-list>
    </v-card>
  </v-container>

   <!-- 로딩 중일 때 보여질 내용 -->
   <v-overlay :value="loading">
     <v-progress-circular
        indeterminate
        color="primary"
     ></v-progress-circular>
   </v-overlay>
</div>
</template>

<script>
  import sideBar from '@/components/sideBar.vue'
  import axios from 'axios'

  export default {
    data: () => ({
      drawer: false,
      show_notice_view: false,
      page: 1,

      category_title: 'Total',
      sub_category : {},
      sub_category_id : 0,
      
      historys: [],
      userinfor : {},

      loading : false, 
    }),
    components: {
      sideBar,
    },

    mounted(){
      this.getUserInfor()
    },
    methods:{
      setSubCategory(sub_category){
        this.drawer = false
        this.sub_category = sub_category
        this.sub_category_id = sub_category.id
        this.category_title = sub_category.name
      },
	
      getUserInfor(){
	    this.loading = true;
            axios
            .get('api/userinfor/user-info/1/')
            .then(res=>{
                this.userinfor = res.data
		this.getHistory()
                // this.userinfor = res.data
                this.loading = false;
            })
            .catch(err=>{
                console.log(err.data)
            })
      },
      getHistory(){
        axios
        .get('api/userinfor/user-history/')
        .then(res=>{
          this.historys = res.data
        })
      },
 
      

      formatDate(dateTimeString) {
          if(dateTimeString==null){
          } else {
              const dateTime = new Date(dateTimeString);
              // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              const options = { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              return dateTime.toLocaleString(undefined, options);
          }
	      },  
      },
      computed:{
        formattedDateTimes() {
          return this.dateTimeStrings.map((dateTimeString) => this.formatDate(dateTimeString));
          },
      }
  }
</script>
